<section class="messwert-filter-section">
  <span class="messwert-list">
    <mat-checkbox class="messwert-filter"
                  [checked]="allComplete"
                  [indeterminate]="someComplete()"
                  (change)="setAll($event.checked);applyFilter()">
      {{source.name}}
    </mat-checkbox>
  </span>
  <span class="messwert-list">
    <mat-checkbox class="messwert-filter" *ngFor="let subsource of source.subSources"
                  [(ngModel)]="subsource.completed"
                  [color]="subsource.color"
                  (ngModelChange)="updateAllComplete();updateSelectedSourceFilter();applyFilter()">
      {{subsource.name}}
    </mat-checkbox>
  </span>
  <span class="messwert-list">
    <mat-checkbox class="messwert-filter"
                  [(ngModel)]="streetType.completed"
                  [color]="streetType.color"
                  (ngModelChange)="applyFilter()">
      {{streetType.name}}
    </mat-checkbox>
  </span>
  <span class="messwert-list">
    <mat-checkbox class="messwert-filter" *ngFor="let r of region"
                  [(ngModel)]="r.completed"
                  [color]="r.color"
                  (ngModelChange)="updateSelectedRegionFilter(r.name);applyFilter()">
      {{r.name}}
    </mat-checkbox>
  </span>
  <mat-chip-list [multiple]="true" style="display: inline-flex" aria-label="Spalten ergänzen/entfernen">
    <mat-chip class="mat-chip-optional-column" [selectable]="true" (click)="addColumn(col)" [selected]="col.selected"
              *ngFor="let col of additionalColumns">{{col.displayName}}</mat-chip>
  </mat-chip-list>
  <span class="menu_spacer"></span>

  <!--  <div class="hide-old-values-toggle-container">-->
  <mat-slide-toggle
    matTooltip="AN: Alle Werte, AUS: Werte mit einem Zeitstempel älter als eine Stunde werden ausgeschlossen"
    class="hide-old-values-toggle" color="accent"
    [(ngModel)]="showValuesOlderOneHour" (change)="onToggleValuesOlderOneHourChange($event)"><strong>Werte
    <1h</strong>
  </mat-slide-toggle>
  <!--  </div>-->
  <span class="menu_spacer"></span>
  <!--  <mat-icon *ngIf="!isRefreshing" class="messwert-filter-icon">filter_list</mat-icon>-->
  <!--  <div class="spinner-container">-->
  <!--    <mat-spinner diameter="20" *ngIf="isRefreshing" mode="indeterminate" color="accent"></mat-spinner>-->
  <!--  </div>-->
  <app-searchbar class="search_form"></app-searchbar>
</section>
